import EventProviderWC from '@ui5/webcomponents-base/dist/EventProvider.js';

export const EventProvider = new EventProviderWC();
